import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_PERSONALARCHIVE_PRIVATE_DOCUMENTS } from './../../shared/constants';

interface IDocuments {
  documentId: string;
  name: string;
  documentType: string;
  date: Date;
  extension: string;
  size: string;
  portfolioNumber?: string;
}

interface PrivateDocumentsListResponse extends ApiResponse {
  documentsList: Array<IDocuments>;
}

@Injectable({
  providedIn: 'root'
})
export class PrivateDocumentsListService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_PERSONALARCHIVE_PRIVATE_DOCUMENTS);
  }

  getDocuments(type: string): Observable<PrivateDocumentsListResponse> {
    return this.get({ type });
  }

  uploadDocuments(formData: FormData): Observable<ApiResponse> {
    return this.postWithButtonLoader(formData);
  }
}

export { PrivateDocumentsListResponse, IDocuments };
